"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragHandle = exports.SortableItem = void 0;
/** @jsx jsx */
var react_1 = require("@emotion/react");
var react_2 = require("react");
var sortable_1 = require("@dnd-kit/sortable");
var utilities_1 = require("@dnd-kit/utilities");
var style_1 = require("../../style");
var SortableItemContext = react_2.createContext({
    attributes: {},
    listeners: undefined,
    ref: function () {
        return;
    },
});
function SortableItem(_a) {
    var children = _a.children, id = _a.id;
    var _b = sortable_1.useSortable({ id: id }), attributes = _b.attributes, isDragging = _b.isDragging, listeners = _b.listeners, setNodeRef = _b.setNodeRef, setActivatorNodeRef = _b.setActivatorNodeRef, transform = _b.transform, transition = _b.transition;
    var context = react_2.useMemo(function () { return ({
        attributes: attributes,
        listeners: listeners,
        ref: setActivatorNodeRef,
    }); }, [attributes, listeners, setActivatorNodeRef]);
    var style = {
        opacity: isDragging ? 0.4 : undefined,
        transform: utilities_1.CSS.Translate.toString(transform),
        transition: transition,
    };
    return (react_1.jsx(SortableItemContext.Provider, { value: context },
        react_1.jsx("li", { ref: setNodeRef, style: style }, children)));
}
exports.SortableItem = SortableItem;
var style = {
    enabled: react_1.css({
        cursor: 'grab',
        ':active': { cursor: 'grabbing' },
    }),
    disabled: react_1.css({
        cursor: 'not-allowed',
    }),
};
function DragHandle(_a) {
    var Icon = _a.sortIcon, sortingEnabled = _a.sortingEnabled;
    var _b = react_2.useContext(SortableItemContext), attributes = _b.attributes, listeners = _b.listeners, ref = _b.ref;
    return (react_1.jsx("div", __assign({}, attributes, listeners, { ref: ref }),
        react_1.jsx(Icon, { color: sortingEnabled ? style_1.DesignSystemThemeColor.Gray.DEFAULT : style_1.DesignSystemThemeColor.Gray.LIGHT_2, css: sortingEnabled ? style.enabled : style.disabled })));
}
exports.DragHandle = DragHandle;
